import { defineStore } from 'pinia'
import { ref } from "vue";
import { request } from "@/ts/request";
import { useCookies } from '@vueuse/integrations/useCookies'
import { RequestStatus } from "@/ts/interfaces/requests/statusEnum";
import router from "@/router"
import { authLogoutPath } from "@/ts/apiRoutes";

const cookies = useCookies(['token'])

export const useAuthLogoutStore = defineStore('api-auth-logout',  () => {
    const status = ref<RequestStatus | null >(RequestStatus.INITIAL)

    async function logout() {
        const response = await request(authLogoutPath, {
            method: 'GET'
        })

        if(response.ok) {
            status.value = RequestStatus.SUCCESS

            cookies.remove('token', { path: '/' })
            cookies.remove('user', { path: '/' })
            router.push({ name: 'login' })
        }
    }

    return { status, logout }
})